<app-new-navbar></app-new-navbar>
<div class="page-content">
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>
